import { config } from '../config.js';
import { session } from './session.js';

/**
 * Cliente da API do TicketCar.
 * - Envia o access token do Cognito.
 * - Se a API responder 401, renova o token uma vez e repete a chamada.
 * - Erros viram ApiError com o formato da API: { status, code, message, details }.
 */

export class ApiError extends Error {
  constructor(status, code, message, details) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

/**
 * @param {'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE'} method
 * @param {string} path  ex.: "/v1/me"
 * @param {unknown} [body]
 */
export async function api(method, path, body, { retry = true } = {}) {
  const token = await session.accessToken().catch(() => null);

  let res;
  try {
    res = await fetch(config.apiUrl + path, {
      method,
      headers: {
        ...(token ? { authorization: `Bearer ${token}` } : {}),
        ...(body !== undefined ? { 'content-type': 'application/json' } : {}),
      },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new ApiError(0, 'NETWORK', 'Não foi possível conectar ao servidor.');
  }

  if (res.status === 401 && retry && session.isLoggedIn) {
    try {
      await session.forceRefresh();
      return api(method, path, body, { retry: false });
    } catch {
      /* cai no tratamento de erro abaixo */
    }
  }

  const data = res.status === 204 ? null : await res.json().catch(() => null);

  if (!res.ok) {
    const e = data?.error ?? {};
    if (res.status === 401) session.expire();
    throw new ApiError(res.status, e.code ?? `HTTP_${res.status}`, e.message ?? 'Erro inesperado.', e.details);
  }
  return data;
}
